export default __webpack_public_path__ + "static/media/horsetelex_logo_with_text_v2.2ec27b07.png";